import React, { useState, useEffect } from "react";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SlideAlert ({
    title,
    isOpen,
    maxWidth,
    setIsOpen,
    children,
    action,
    disableBackdrop = false
}) {

    const handleClose = (event, reason) => {
      if (disableBackdrop && (reason && reason === "backdropClick")) {
        return;
      }
      setIsOpen(false)
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={maxWidth}
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {children}
              </DialogContentText>
            </DialogContent>
            {
              action &&
              <DialogActions>
                {action}
              </DialogActions>
            }
        </Dialog>
    )
}

export default SlideAlert;